export default {
      id: "arrow-up-usage",
      viewBox: "0 0 13 43",
      url: "../../assets/" + "sprite.svg#arrow-up-usage",
      toString: function () {
        return this.url;
      }
    }